import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";

export default function UserSelection({ users = [], setEventData, eventDat }) {
  return (
    <Listbox
      value={eventDat?.uid}
      onChange={(e) =>
        setEventData((prev) => ({
          ...prev,
          uid: e,
          user: users?.find((user) => user?.uid === e)?.fullname || "",
        }))
      }
    >
      <ListboxButton
        className={clsx(
          "relative block w-full rounded-lg bg-white py-2.5 pr-8 pl-3 text-left text-sm/6 border-gray-300 border text-black shadow-sm",
          "focus:outline-none focus:ring-2 focus:ring-white",
        )}
      >
        {users?.find((user) => user?.uid === eventDat?.uid)?.fullname ||
          "Επιλέξτε ομιλητή"}
        <ChevronDownIcon
          className="group pointer-events-none absolute top-2.5 right-2.5 size-4 text-black"
          aria-hidden="true"
        />
      </ListboxButton>

      <ListboxOptions
        anchor="bottom"
        transition
        className={clsx(
          "w-[var(--button-width)] z-10 border border-gray-300 rounded-xl bg-white p-1 shadow-lg [--anchor-gap:var(--spacing-1)] focus:outline-none",
          "transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0",
        )}
      >
        {users.map((person) => (
          <ListboxOption
            key={person.fullname}
            value={person.uid}
            className="group flex cursor-default items-center gap-2 rounded-lg py-1.5 px-3 select-none data-[focus]:bg-gray-100"
          >
            <CheckIcon className="invisible size-4 text-black group-data-[selected]:visible" />
            <div className="text-sm/6 text-black">{person.fullname}</div>
          </ListboxOption>
        ))}
      </ListboxOptions>
    </Listbox>
  );
}
